import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { APPROACH } from "../../data/content";
import { SectionHead } from "../common/Section";

gsap.registerPlugin(ScrollTrigger);

export default function Approach() {
  const root = useRef(null);
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(".approach-line", { scaleX: 0 }, {
        scaleX: 1, ease: "none", transformOrigin: "left center",
        scrollTrigger: { trigger: root.current, start: "top 75%", end: "bottom 60%", scrub: true },
      });
      gsap.from(".approach-step", {
        y: 40, opacity: 0, stagger: 0.15, duration: 0.8, ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 70%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} data-testid="approach-section" className="bg-white py-24 lg:py-32">
      <div className="container-q">
        <SectionHead eyebrow="Our Approach" title="A disciplined process, built around you." text="Every Quantora engagement follows the same transparent four-stage framework." />
        <div className="relative mt-16">
          <div className="approach-line absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-gold via-mint to-gold lg:block" />
          <div className="grid gap-10 lg:grid-cols-4">
            {APPROACH.map((s) => (
              <div key={s.step} className="approach-step relative">
                <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-gold/50 bg-white font-num text-sm font-semibold text-navy shadow-[0_0_0_6px_white]">{s.step}</div>
                <h3 className="mt-6 text-xl font-bold text-navy">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
